import _taggedTemplateLiteral from "babel-runtime/helpers/taggedTemplateLiteral";
import _objectWithoutProperties from "babel-runtime/helpers/objectWithoutProperties";

var _templateObject = _taggedTemplateLiteral(["\n    ", ";\n    min-height: ", "px;\n  "], ["\n    ", ";\n    min-height: ", "px;\n  "]),
    _templateObject2 = _taggedTemplateLiteral(["\n    margin-top: 40px;\n  "], ["\n    margin-top: 40px;\n  "]),
    _templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 20px;\n    min-height: 60px;\n  "], ["\n    ", ";\n    margin-bottom: 20px;\n    min-height: 60px;\n  "]),
    _templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n    min-height: 240px;\n    padding: 20px;\n  "], ["\n    ", ";\n    min-height: 240px;\n    padding: 20px;\n  "]),
    _templateObject5 = _taggedTemplateLiteral(["\n  bottom: 25px;\n  position: absolute;\n  right: 25px;\n  z-index: 120;\n\n  transition: bottom ", "ms ease;\n  &.entering,\n  &.entered {\n    display: none;\n  }\n  &.exiting {\n    bottom: -100px;\n  }\n  &.exited {\n    bottom: 25px;\n  }\n"], ["\n  bottom: 25px;\n  position: absolute;\n  right: 25px;\n  z-index: 120;\n\n  transition: bottom ", "ms ease;\n  &.entering,\n  &.entered {\n    display: none;\n  }\n  &.exiting {\n    bottom: -100px;\n  }\n  &.exited {\n    bottom: 25px;\n  }\n"]);

import React from "react";
import styled, { css, keyframes } from "styled-components";
import Color from "color";

import { get, mixin, bigPhone } from "../../style/util";

import Button from "../Button";

var height = 120;
var maxLineForQuestions = 5;
var lineHeight = (height - 10 * 2) / maxLineForQuestions;

var height700 = 160;
var maxLineForQuestions700 = 6;
var lineHeight700 = (height700 - 10 * 2) / maxLineForQuestions700;

export var TRANSITION_DURATION_IN_MS = 500;

var questionTextEnterAnimation = keyframes(["0%{left:100vw;}50%{left:0;}"]);
var QuestionText = styled(function (_ref) {
  var children = _ref.children,
      index = _ref.index,
      total = _ref.total,
      props = _objectWithoutProperties(_ref, ["children", "index", "total"]);

  return React.createElement(
    "h2",
    props,
    children,
    React.createElement(
      "span",
      { className: "Number" },
      index,
      "/",
      total
    )
  );
}).withConfig({
  componentId: "s1z0hsho-0"
})(["", ";align-items:center;display:flex;justify-content:stretch;background:#ffffff;border-radius:8px;box-sizing:border-box;color:", ";min-height:", "px;padding:10px 50px 10px 20px;position:relative;", ";&.entering{animation:", " ", "ms ease;animation-fill-mode:forwards;}.Number{", ";background:", ";border:3px solid #ffffff;border-radius:100%;color:", ";height:54px;position:absolute;right:-15px;text-align:center;top:-15px;width:54px;}"], mixin("font.bold", 18, lineHeight + "px"), get("color.standard"), height, bigPhone(_templateObject, mixin("font.bold", 20, lineHeight700 + "px"), height700), questionTextEnterAnimation, TRANSITION_DURATION_IN_MS, mixin("font.bold", 20, "54px"), get("color.bullet"), get("color.bulletText"));

export { QuestionText };
var answerGroupEnterAnimation = keyframes(["0%{left:100%;}50%{left:0%;}100%{left:0%;}"]);
var answerGroupShowExplanationAnimation = keyframes(["0%{left:0%;}50%{left:0%;}100%{left:-100%;}"]);
export var AnswerGroup = styled(function (_ref2) {
  var className = _ref2.className,
      children = _ref2.children;

  return React.createElement(
    "div",
    { className: className },
    React.createElement(
      "div",
      { className: "Container" },
      children.map(function (child, index) {
        return React.createElement(
          "div",
          { key: index, className: "Block" },
          child
        );
      })
    )
  );
}).withConfig({
  componentId: "s1z0hsho-1"
})(["margin:0 -25px;overflow:hidden;", ";> .Container{position:relative;overflow:hidden;width:", ";> .Block{box-sizing:border-box;display:inline-block;overflow:hidden;padding:0 25px;vertical-align:top;width:", ";}}&.entering > .Container{animation:", " ", "ms ease;animation-fill-mode:forwards;}&.entered > .Container{left:0;}&.exiting > .Container{animation:", " ", "ms ease;animation-fill-mode:forwards;},&.exited > .Container{left:-100%;}"], bigPhone(_templateObject2), function (_ref3) {
  var children = _ref3.children;
  return children.length * 100 + "%";
}, function (_ref4) {
  var children = _ref4.children;
  return 100 / children.length + "%";
}, answerGroupEnterAnimation, TRANSITION_DURATION_IN_MS, answerGroupShowExplanationAnimation, TRANSITION_DURATION_IN_MS);

export var Answers = styled.div.withConfig({
  componentId: "s1z0hsho-2"
})(["left:0;padding:0;position:relative;width:100%;"]);

var answerButtonAppearDurationInPc = 50;
var answerButtonOffsetDurationInPc = 10;
var answerButtonEnterAnimation = function answerButtonEnterAnimation(order) {
  return keyframes(["25%{left:100vw;}", "%{left:100vw;}", "%{left:0;}100%{left:0;}"], 25 + answerButtonOffsetDurationInPc * order, 25 + answerButtonOffsetDurationInPc * order + answerButtonAppearDurationInPc);
};
var answerButtonExitAnimation = function answerButtonExitAnimation(order) {
  return keyframes(["0%{left:0;}", "%{left:0;}", "%{left:-100vw;}100%{left:-100vw;}"], answerButtonOffsetDurationInPc * order, answerButtonOffsetDurationInPc * order + answerButtonAppearDurationInPc);
};

var AnswerButton = styled(function (_ref5) {
  var valid = _ref5.valid,
      props = _objectWithoutProperties(_ref5, ["valid"]);

  return React.createElement("button", props);
}).withConfig({
  componentId: "s1z0hsho-3"
})(["", ";align-items:center;display:flex;justify-content:stretch;background:#ffffff;border:0;border-radius:8px;box-sizing:border-box;color:", ";min-height:50px;margin:0 0 10px 0;padding:5px 20px;position:relative;text-align:left;transition:all 0.15s ease;transition-property:background,color;width:100%;", ";", " &:hover,&:active{background:", ";}&:active{", ";}"], mixin("font.bold", 16, "20px"), get("color.standard"), bigPhone(_templateObject3, mixin("font.bold", 18, "20px")), function (_ref6) {
  var index = _ref6.index,
      total = _ref6.total;
  return css(["&.entering{animation:", " ", "ms ease;animation-fill-mode:forwards;}&.exiting{animation:", " ", "ms ease;animation-fill-mode:forwards;}&.exited{left:0;}"], answerButtonEnterAnimation(index), TRANSITION_DURATION_IN_MS, answerButtonExitAnimation(total - 1 - index), TRANSITION_DURATION_IN_MS);
}, Color("#fff").darken(0.15).toString(), function (_ref7) {
  var valid = _ref7.valid;
  return valid ? css(["background:", ";color:", ";"], get("color.success"), get("color.successText")) : css(["background:", ";color:", ";"], get("color.error"), get("color.errorText"));
});

export { AnswerButton };
var Explanation = styled(function (_ref8) {
  var children = _ref8.children,
      title = _ref8.title,
      valid = _ref8.valid,
      props = _objectWithoutProperties(_ref8, ["children", "title", "valid"]);

  return React.createElement(
    "div",
    props,
    React.createElement(
      "h3",
      null,
      title
    ),
    React.createElement(
      "p",
      null,
      children
    )
  );
}).withConfig({
  componentId: "s1z0hsho-4"
})(["", ";align-items:flex-start;display:flex;flex-direction:column;justify-content:center;", ";border-radius:8px;box-sizing:border-box;min-height:210px;margin:0;padding:10px 20px;position:relative;width:100%;flex:1;", ";h3{", ";margin:0;margin-bottom:10px;padding:0;}p{", ";display:flex;flex:1;margin:0;padding:0;strong{", ";}}"], mixin("font.default", 14, 1.2), function (_ref9) {
  var valid = _ref9.valid;
  return valid ? css(["background:", ";color:", ";"], get("color.success"), get("color.successText")) : css(["background:", ";color:", ";"], get("color.error"), get("color.errorText"));
}, bigPhone(_templateObject4, mixin("font.default", 16, 1.2)), mixin("font.bold", 18), get("style.answerAlignment"), mixin("font.bold"));

export { Explanation };
export var NextButton = Button.extend(_templateObject5, TRANSITION_DURATION_IN_MS);
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/Question/style.js
// module id = 419
// module chunks = 0